// src/layouts/DashboardLayout.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import api from "../core/api";
import "./DashboardLayout.css";
import BaleGuard from "../components/BaleGuard";

const API_BASE = api.defaults.baseURL || "";
const fullUrl = (u) =>
  !u ? null : /^(https?:|blob:|data:)/.test(u) ? u : `${API_BASE}${u}`;

export default function DashboardLayout() {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [menu, setMenu] = useState(null); // { brand, items }

  const loadMenu = useCallback(async () => {
    try {
      const res = await api.get("/menu");
      setMenu({ brand: res.data.brand, items: res.data.items || [] });
    } catch (err) {
      console.error("خطا در دریافت منو:", err);
      setMenu((prev) => prev || { brand: { name: "", logo: null }, items: [] });
    }
  }, []);

  useEffect(() => {
    loadMenu();
    // بعد از ذخیره/آپلود در تنظیمات، برند دوباره خوانده شود
    window.addEventListener("company-updated", loadMenu);
    return () => window.removeEventListener("company-updated", loadMenu);
  }, [loadMenu]);

const [loggingOut, setLoggingOut] = useState(false);

const handleLogout = async () => {
  if (loggingOut) return;
  setLoggingOut(true);
  try {
    // session ro dar db revoke mikone
    await api.post("/auth/logout");
  } catch (err) {
    // agar 401 bashe yani session az ghabl batel shode, mohem nist
    console.error("خطا در خروج:", err);
  } finally {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  }
};

  const closeMobile = () => setMobileOpen(false);

  const logo = fullUrl(menu?.brand.logo);
  const companyName = menu?.brand.name;
  const brandText = "حساب داری نگاریار";

  return (
    <div className={`dashboard-layout ${collapsed ? "collapsed" : ""}`}>
      <button
        className="mobile-toggle"
        onClick={() => setMobileOpen((v) => !v)}
        aria-label="باز کردن منو"
      >
        <i className="fa-solid fa-bars" />
      </button>

      {mobileOpen && <div className="sidebar-overlay" onClick={closeMobile} />}

      <aside className={`sidebar ${mobileOpen ? "mobile-open" : ""}`}>
        <div className="sidebar-header">
          <div className="brand" title={brandText}>
            <div className={`brand-logo ${logo ? "has-img" : ""}`}>
              {logo ? <img src={logo} alt="لوگو" /> : "ف"}
            </div>
            <span className={`brand-name ${!companyName ? "pending" : ""}`}>
              {brandText}
            </span>
          </div>
          <button
            className="collapse-btn"
            onClick={() => setCollapsed((v) => !v)}
            aria-label="جمع کردن منو"
            title={collapsed ? "باز کردن" : "جمع کردن"}
          >
            <i
              className={`fa-solid ${
                collapsed ? "fa-angles-right" : "fa-angles-left"
              }`}
            />
          </button>
        </div>

        <nav className="sidebar-nav">
          {!menu
            ? [1, 2, 3, 4, 5].map((i) => <div key={i} className="nav-skel" />)
            : menu.items.map((item) => (
                <NavLink
                  key={item.key}
                  to={item.to}
                  end={item.end}
                  title={collapsed ? item.label : undefined}
                  className={({ isActive }) =>
                    `nav-item ${isActive ? "active" : ""}`
                  }
                  onClick={closeMobile}
                >
                  <span className="nav-icon">
                    <i className={`fa-solid ${item.icon}`} />
                  </span>
                  <span className="nav-label">{item.label}</span>
                </NavLink>
              ))}
        </nav>

        <div className="sidebar-footer">
    <button className="btn logout-btn" onClick={handleLogout} disabled={loggingOut}>
  <span className="nav-icon">
    <i className={`fa-solid ${loggingOut ? "fa-spinner fa-spin" : "fa-right-from-bracket"}`} />
  </span>
  <span className="nav-label">{loggingOut ? "در حال خروج..." : "خروج"}</span>
</button>
        </div>
      </aside>

      <main className="content">
        <BaleGuard>
        <Outlet />
        </BaleGuard>
      </main>
    </div>
  );
}